import { Link } from 'react-router-dom';
import { Mail, Phone, GraduationCap } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-brand-dark text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <GraduationCap className="h-6 w-6 text-brand-blue" />
              <span className="text-xl font-bold font-display">Tutor Flex</span>
            </div>
            <p className="text-slate-300 text-sm">
              Master Engineering, JEE & NEET Concepts with Expert Guidance
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4 font-display">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-slate-300 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/courses" className="text-slate-300 hover:text-white transition-colors">Courses</Link></li>
              <li><Link to="/teachers" className="text-slate-300 hover:text-white transition-colors">Teachers</Link></li>
              <li><Link to="/contact" className="text-slate-300 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4 font-display">Services</h3>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li>1:1 Tutoring</li>
              <li>Group Classes</li>
              <li>JEE Preparation</li>
              <li>NEET Preparation</li>
              <li>Engineering Subjects</li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4 font-display">Contact</h3>
            <ul className="space-y-3 text-slate-300 text-sm">
              <li className="flex items-center space-x-2">
                <Mail className="h-4 w-4" />
                <span>kaushaltutor@gmail.com</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="h-4 w-4" />
                <span>+91 9693339188</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-8 pt-8 text-center text-slate-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Tutor Flex. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
